import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonSocialSharedComponent } from './button-social.component';

@NgModule({
    declarations: [
        ButtonSocialSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ButtonSocialSharedComponent
    ]
})

export class ButtonSocialSharedModule {}
